import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import Stack from 'react-bootstrap/Stack';
import { FormContext } from 'context/FormContext';
import { fetchSimulationData, fetchConfiguratorData, getBatteryTypes, getStorageConfigList } from 'services/simulatorApiProxy';
import { parseHashQueryParams } from 'services/routingHelper'
import ImageLoading from 'assets/images/loading.gif';
import BackgroundDefault from 'assets/images/produkte-e3dc-2026.png';

const QRCodeEvaluation = () => {
    const { setFormValues, setResultValues, setBatteryTypes, setStorageConfiguration } = useContext(FormContext);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true); // Loading state to control spinner display
    const [error, setError] = useState(false);
    const didFetch = useRef(false);

    // fetch simulation result
    // fetch configurator result
    // should we just add our result in wordpress when we call fetch simulation?
    useEffect(() => {
        // prevent double api request in dev mode
        if (didFetch.current) return;
        didFetch.current = true;

        const fetchData = async () => {
            try {

                const query = parseHashQueryParams();
                if (!query.id) {
                    throw new Error('Parameter id is missing');
                }

                const simulationDataRequest = fetchSimulationData(query.id);
                const configuratorDataRequest = fetchConfiguratorData(query.id);
                const batteryTypesRequest = getBatteryTypes();
                const storageConfigRequest = getStorageConfigList();

                const [simulationData, configuratorData, batteryTypes, storageConfig] = await Promise.all([
                    simulationDataRequest,
                    configuratorDataRequest,
                    batteryTypesRequest,
                    storageConfigRequest
                ]);

                // remove old product
                if (storageConfig.PROSERIE) {
                    delete storageConfig.PROSERIE;
                }

                setBatteryTypes(batteryTypes);
                setStorageConfiguration(storageConfig);
                setFormValues(configuratorData);
                setResultValues(simulationData);

                navigate('/SimulationResult');
            } catch (error) {
                console.error('Error during request:', error);
                setError(true);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [navigate]);

    const backgroundStyle = {
        background: `url(${BackgroundDefault}) no-repeat`,
        backgroundSize: '100%',
        backgroundPosition: 'right bottom',
    };

    return (
        <Stack gap={4} className="ContainerPaddingSmall text-center" style={backgroundStyle}>
            <h1>Nur noch wenige Sekunden...</h1>
            <div>Ihre Konfiguration wird finalisiert – gleich sehen Sie Ihr persönliches Ergebnis</div>
            <div className="d-flex justify-content-center">
                {isLoading ? (
                    <img src={ImageLoading} className="LoadingAnimation" alt="Loading..." width="150" height="150" />
                ) : error ? (
                    <div className="text-danger">Es gab ein Problem mit der Anfrage. Bitte versuchen Sie es später noch einmal.</div>
                ) : (
                    <div>Die Auswertung ist abgeschlossen!</div>
                )}
            </div>
        </Stack>
    )
}

export default QRCodeEvaluation;